import { Fragment, useEffect, useRef, useState } from "react";
import { Dialog, Listbox, Menu, Transition } from "@headlessui/react";
import {
    CheckIcon,
    ChevronDownIcon,
} from "@heroicons/react/24/outline";

import EmojiTextArea from 'react-input-emoji';
import {
    LockClosedIcon,
} from '@heroicons/react/20/solid';

import { Check, CaretRightFill, CircleFill, CheckAll, Send, Fullscreen, Magic, ArrowClockwise, FullscreenExit, ArrowCounterclockwise, ClockHistory, Person, X } from 'react-bootstrap-icons';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import loader_dot from "../../assets/dot.gif"
import Toast from "../assetLibComponents/shared/Toast";
import { appUserActivity } from "../../redux/actions/crmActions";
import zoiReadingEmote from "../../assets/zoiReadingEmote.gif"
import "../chatAiComponents/ChatAii.css"
import "../liveChat/livechat.css"
import { ref, onValue, update, set } from 'firebase/database';
import { db } from '../../firebase'; // Update the path to your firebaseConfig.js file
import { fetchChatStatus, fetchLiveChatListing, fetchAiAssist, getLeadSelectedData, sendMessage, assignConversationLead, fetchCannedListing } from "../../redux/actions/liveChatActions";
import Cookies from "js-cookie";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const assistStatus = [
  { id: 1, name: 'Summarize Conversation' },
  { id: 2, name: 'Make more friendly' },
  { id: 3, name: 'Make more formal' },
  { id: 4, name: 'Rephrase' },
]

export default function Inbox(props) {
    // const [tabName, setTabName] = useState("Mine");
    const params = new URLSearchParams(window.location.search);
    const newId1 = params.get('inbox');
    const newId2 = params.get('conversation');
    const pageName = window.location.pathname.slice(10);
    const listRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [selectedCannedResponseData, setSelectedCannedResponseData] = useState(null);
    // const { id1, id2 } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const messageEl = useRef(null);
    const fileInputRef = useRef(null);
    const cancelButtonRef = useRef();
    const authToken = props.authToken;
    const [userData, setUserData] = useState([]);
    const [name, setName] = useState("");
    const [show, setShow] = useState(false);
    const [listChatFlag, setListChatFlag] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [assignSelf, setAssignSelf] = useState(false);
    const [loaderGif, setLoaderGif] = useState(false);
    const [assistAction, setAssistAction] = useState("");
    const [searchCanned, setSearchCanned] = useState("");
    const [assistMessage, setAssistMessage] = useState("");
    const [aiResponse, setAiResponse] = useState("");
    const [liveChatPrompt, setLiveChatPrompt] = useState([]);
    const [firebaseSwitch, setFirebaseSwitch] = useState(false);
    const [typingObject, setTypingObject] = useState(false);
    const [firebaseFlag, setFirebaseFlag] = useState(false);
    const [editorStatus, setEditorStatus] = useState("reply");
    const [selectedPublish, setSelectedPublish] = useState("reopen")
    const [listingData, setListingData] = useState(null);
    const [assistPop, setAssistPop] = useState(false);
    const [error, setError] = useState(false);
    const [text, setText] = useState('');
    
    const num_client_id = useSelector((state) => state.assetLibrary?.userData?.new_client_id);
    
    const userDetails = useSelector(
        (state) => state.crmLeads.userActivityDetails
    );
    const live_chat_listing = useSelector(
        (state) => state.livechat.live_chat_listing
    );
    
    const live_bot_listing = useSelector(
        (state) => state.livechat.live_bot_listing
    ); 
    
    const agentCaptureData = useSelector(
        (state) => state.assetLibrary.userData
    );
    
    const canned_list = useSelector(
        (state) => state.livechat.canned_listing
    );
    
    const lead_id_store = useSelector(
        (state) => state.livechat.live_bot_listing?.lead_id
    ); 
    
    const token = useSelector(
        (state) => state.livechat.live_bot_listing?.prospect_token
    );
    
    const user_detail_left = useSelector(
        (state) => state.crmLeads.userActivityDetails?.data?.lead_response
    );
    
    const user_detail = useSelector(
        (state) => state.crmLeads.userActivityDetails?.data?.response
    );
    
    const fetch_agent_id = useSelector(
        (state) => state.assetLibrary?.userData?.id
    );
    
    const fetch_select_data = useSelector(
        (state) => state.livechat.lead_select_data?.data
    );

    useEffect(() => {
        setName(userDetails?.data?.response?.name);
        if (user_detail_left?.length > 0) {
            user_detail_left.map(async (obj, o_ind) => {
                if (obj?.options?.length > 0 && obj.values !== null) {
                    const objData = await obj.options.find(
                        (option) => option.id == obj.values
                    );
                    obj.values = objData;
                }
                return obj;
            });
        }
        setUserData(user_detail_left);
    }, [user_detail_left]);
    
    const onLiveChatSuccess = (value) => {
        Cookies.set("p_t", value?.prospect_token)
        const arrayData = [...value?.data];
        const liveChatRef = ref(
            db,
            `/users/${num_client_id}/Livechat/${value?.prospect_token}/conversation`
        );
        const onIdStatusChange = onValue(liveChatRef, (snapshot) => {
            const idStatus = snapshot.val();
            if (idStatus !== null && arrayData?.length != idStatus?.length) {
                console.log(idStatus);
                props.fetchQueryParams();
                // let data = [...arrayData, ...idStatus];
                setLiveChatPrompt(idStatus);
            } else {
                setLiveChatPrompt(arrayData)
            }
        });

        return () => {
            // Cleanup by detaching the listener when component unmounts
            onIdStatusChange();
        };
    }
    
    useEffect(() => {
        dispatch(fetchCannedListing(authToken , 'self', searchCanned));
    }, [searchCanned])
    
    
    // useEffect(() => {
    //     let tokenNew = Cookies.get("p_t");
    //     const typingRef = ref(
    //         db,
    //         `/users/${num_client_id}/Livechat/${tokenNew}/chatTyping`
    //     );
    //     const onIdStatusChange = onValue(typingRef, (snapshot) => {
    //         const idStatus = snapshot.val();
    //         if (idStatus !== null) {
    //             setTypingObject(idStatus)
    //         }
    //     });

    //     return () => {
    //         // Cleanup by detaching the listener when component unmounts
    //         onIdStatusChange();
    //     };
    // }, [])
    
    
    useEffect(() => {
        dispatch(fetchLiveChatListing(authToken, props.inboxParam, props.conversationParam, "pass", onLiveChatSuccess));
        setTimeout(() => {
            dispatch(getLeadSelectedData(authToken, props.inboxParam, props.conversationParam)); 
        }, 100);
    }, [props.inboxParam])
    
    // useEffect(() => {
    //     const assignAgentRef = ref(db, `/users/${num_client_id}/Livechat/${token}/chatTyping`);
    //     const onIdStatusChange = onValue(assignAgentRef, (snapshot) => {
    //     const idStatus = snapshot.val();
    //         // if (idStatus !== null) {
    //             // Assuming you want to update a key named 'updatedKey' with a boolean value
    //             const newData = { ...idStatus, agentKey: firebaseFlag }; // Modify as per your requirements

    //             // Update the data in Firebase
    //             set(assignAgentRef, newData)
    //             .then(() => console.log("Data updated successfully"))
    //             .catch((error) => console.error("Error updating data: ", error));
    //         // }
    //     });
    //     return () => {
    //         // Cleanup by detaching the listener when component unmounts
    //         onIdStatusChange();
    //     };
    // }, [firebaseFlag]);
    
    const onSuccessResponse = () => {
        setFirebaseSwitch(true);
        dispatch(fetchLiveChatListing(authToken, props.inboxParam, props.conversationParam, "pass", onLiveChatSuccess));
    }

    useEffect(() => {
        setSelectedPublish(fetch_select_data?.ticket_status);
        // publishHandle(fetch_select_data?.ticket_status);
    }, [fetch_select_data])
    
    
    useEffect(() => {
        setListingData(live_chat_listing);
    }, [live_chat_listing])
    
    
    const handleEmojiClick = (emoji) => {
        setText((prevText) => prevText + emoji);
    };
    
    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        console.log('Selected file:', selectedFile);
        // You can now do something with the selected file, like uploading it to a server
    };
    
    // useEffect(() => {
    //     if (messageEl?.current) {
    //         messageEl?.current?.addEventListener('DOMNodeInserted', event => {
    //             const { currentTarget: target } = event;
    //             target.scroll({ top: target.scrollHeight});
    //         });
    //     }
    // }, [])
    
    // useEffect(() => {
    //     if (messageEl.current) {
    //         messageEl.current.scrollTo({
    //             top: messageEl.current.scrollHeight,
    //             behavior: 'smooth'
    //         });
    //     }
    // }, []);
    
    const scrollChatToBottom = () => {
        if (messageEl.current) {
            messageEl.current.scrollTop = messageEl.current.scrollHeight;
        }
    };

    // Effect to scroll to the bottom when messages change
    useEffect(() => {
        scrollChatToBottom();
    }, [liveChatPrompt]);
    
    const onSuccess = (value) => {
        setAiResponse(value)
        setLoaderGif(false);
    }
    
    const onFailure = () => {
        setLoaderGif(false);
    }
    
    const handleAiAssist = (action) => {
        setLoaderGif(true);
        setTimeout(() => {
            dispatch(fetchAiAssist(authToken, props.inboxParam, props.conversationParam, assistMessage, action, onSuccess, onFailure));
        }, 4000);
       
    }    
    
    const publishHandle = (publish) => {
        if (publish === "reopen") {
            return (
                <>
                    <CheckIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                    <p className="text-sm font-semibold">Resolve</p>
                </>
            );
        } else if (publish === "resolve" || publish === "resolved" ) {
            return (
                <>
                    <ArrowCounterclockwise className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                    <p className="text-sm font-semibold">Reopen</p>
                </>
            );
        } else {
            return (
                <>
                    <Person className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                    <p className="text-sm font-semibold">Open</p>
                </>
            );
        }
        
    }
    
    const getChars = (str) => {
        if (str === "") {
        return;
        }
        const firstLetters = str
        .split(" ")
        .slice(0, 2)
        .map((word) => word[0])
        .join("")
        .toUpperCase();
        return firstLetters;
    };
    
    const handleClose = () => {
        setAiResponse("");
        setAssistAction("");
        setAssistMessage("");
        setAssistPop(false);
    }
    
    const CannedResponseOverlay = () => {
        // Implement overlay content here
        return (
            <div className="absolute bottom-[100%] bg-white w-full max-h-48 overflow-y-auto p-2">
            {/* <Listbox
                // value={selectedCannedResponseData}
                // onChange={(e) => {
                //     // let payload = {
                //     //     inbox_id: newId1,
                //     //     channel_id: "1",
                //     //     conversation_id: newId2,
                //     //     conversation_status: e.id,
                //     //     priority: e.name,
                //     // }
                //     // dispatch(assignConversationLead(authToken,payload, newId1, newId2))
                //     setSelectedCannedResponseData(e)
                // }}    
            >
                        <div className="relative mt-1 mb-4">
                                <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                    {canned_list?.length && canned_list?.map((item, c_index) => (
                                        <Listbox.Option
                                            key={item.id}
                                            className={({ active }) =>
                                                classNames(
                                                    active
                                                        ? "bg-gray-100 text-gray-900"
                                                        : "text-gray-900",
                                                    "relative cursor-default select-none py-2 pl-3 pr-9"
                                                )
                                            }
                                            value={item}
                                        >
                                            {({ selected, active }) => (
                                                <>
                                                    <span
                                                        className={classNames(
                                                            selected
                                                                ? "font-semibold"
                                                                : "font-normal",
                                                            "flex items-center gap-2 truncate"
                                                        )}
                                                    >
                                                        {item.message}
                                                    </span>

                                                    {selected ? (
                                                        <span
                                                            className={classNames(
                                                                active
                                                                    ? "text-[var(--brand-primary)]"
                                                                    : "text-[var(--brand-primary)]",
                                                                "absolute inset-y-0 right-0 flex items-center pr-4"
                                                            )}
                                                        >
                                                        </span>
                                                    ) : null}
                                                </>
                                            )}
                                        </Listbox.Option>
                                    ))}
                                </Listbox.Options>
                        </div>
            </Listbox> */}
            <ul ref={listRef}>
                {canned_list?.length > 0 && canned_list?.map((item, c_index) => {
                    return (
                        <>
                        <li
                            onClick={() => {
                                const newText = text.replace(`/${searchCanned}`, item?.message);
                                setText(newText);
                                setShowOverlay(false);
                            }}
                            className={`py-2 px-4 cursor-pointer rounded-md my-1 ${c_index === activeIndex ? "active bg-[color-mix(in_srgb,var(--brand-primary)_19%,transparent)]":""}`}
                        >
                            <span className="text-sm">{item.message}</span>   
                            <p className="text-xs">{ item.short_code }</p>
                        </li>
                        <hr/>
                        </>
                    );
                })}
            </ul>
            </div>
        );
    };
    
    useEffect(() => {
        const handleKeyDown = (event) => {
        if (event.key === 'ArrowUp') {
            setActiveIndex((prevIndex) => Math.max(0, prevIndex - 1));
        } else if (event.key === 'ArrowDown') {
            setActiveIndex((prevIndex) => Math.min(canned_list.length - 1, prevIndex + 1));
        }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
        window.removeEventListener('keydown', handleKeyDown);
        };
    }, [canned_list]);
    
    // useEffect(() => {
    //     if (listRef.current) {
    //         const activeItem = listRef.current.querySelector('.active');
    //         debugger;
    //     if (activeItem) {
    //         activeItem.scrollIntoView({
    //         behavior: 'smooth',
    //         block: 'nearest',
    //         inline: 'start',
    //         });
    //     }
    //     }
    // }, [activeIndex]);
    
    return (
        <>
            <>
                <header className="flex bg-gray-50 items-center justify-between border-b border-white/5 max-xl:p-2 p-4 ">
                    <div className="flex items-center gap-2">
                        <div
                            className="bg-[var(--brand-primary)] relative w-9 text-center text-white p-[0.4rem] rounded-full"
                            title={ user_detail?.name }
                        >
                            {getChars(user_detail?.name || "Unknown")}
                            {/* <CircleFill className="text-green-700 border border-white rounded-full absolute right-[-4px] bottom-[-4px]"/> */}
                        </div>
                        <h1 className="text-base font-semibold leading-7 text-black">
                            {user_detail?.name || "Unknown"}
                        </h1>
                    </div>
                    <Listbox
                        value={selectedPublish}
                        onChange={(e) => {
                            setSelectedPublish(e);
                            dispatch(fetchChatStatus(authToken, props.inboxParam, props.conversationParam, "pending"))
                        }}
                    >
                        {({ open }) => (
                            <>
                            <div className="relative">
                                    <div className={`inline-flex divide-x ${selectedPublish === "resolve" || selectedPublish === "resolved" ? "divide-yellow-500" : selectedPublish === "pending" ? "divide-[var(--brand-primary)]" : "divide-green-600"} divide-[var(--brand-primary)] rounded-md shadow-sm`}>
                                <div
                                    onClick={() => { 
                                        let data = selectedPublish;        
                                        if (selectedPublish === "resolve") {
                                            setSelectedPublish("reopen");
                                            data = "reopen";
                                        } else if (selectedPublish === "reopen") {
                                            setSelectedPublish("resolve");
                                            data = "resolved";
                                        } else {
                                            setSelectedPublish("reopen");
                                            data = "reopen";
                                        }
                                        dispatch(fetchChatStatus(authToken, props.inboxParam, props.conversationParam, data))                                                
                                    }}
                                    className={`cursor-pointer inline-flex border-r border-white items-center gap-x-1.5 ${selectedPublish !== "pending" ? "rounded-l-md" : "rounded-md"} ${selectedPublish === "resolve" || selectedPublish === "resolved" ? "bg-yellow-500" : selectedPublish === "pending" ? "bg-[var(--brand-primary)]" : "bg-green-600"} px-3 py-2 text-white shadow-sm`}>
                                    {publishHandle(selectedPublish)}
                                </div>
                                {selectedPublish !== "pending" && <Listbox.Button className={`"inline-flex border-l border-white items-center rounded-l-none rounded-r-md p-2 focus:outline-none  ${selectedPublish === "resolve" || selectedPublish === "resolved" ? "bg-yellow-500" : selectedPublish === "pending" ? "bg-[var(--brand-primary)]" : "bg-green-600"} "`}>
                                    <ChevronDownIcon className="h-5 w-5 text-white" aria-hidden="true" />
                                </Listbox.Button>}
                                </div>

                                <Transition
                                    show={open}
                                    as={Fragment}
                                    leave="transition ease-in duration-100"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                >
                                <Listbox.Options className="absolute right-0 z-10 mt-2 w-40 origin-top-right divide-y divide-gray-200 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                    {/* { title: 'Mark as pending', icon: 'This job posting will no longer be publicly accessible.', current: false }, */}
                                    <Listbox.Option className="cursor-pointer" value="pending">
                                        <div className="flex py-2 px-2 flex-col">
                                            <div className="flex justify-between">
                                                <span>
                                                    <ClockHistory className="h-5 w-5" aria-hidden="true" />
                                                </span>
                                                <p className="font-medium">Mark as pending</p>
                                            </div>
                                        </div>
                                    </Listbox.Option>
                                </Listbox.Options>
                                </Transition>
                            </div>
                            </>
                        )}
                        </Listbox>
                </header>
                <div ref={messageEl} className="bg-gray-100 conversation-panel overflow-y-auto listing pb-0 px-4 pt-4">
                    {(listChatFlag !== false || live_bot_listing?.summary == "") && live_bot_listing?.bot_data?.map((chat_bot, c_index) => {
                        return (
                            <>
                                <>
                                    <div className='bubble-left relative mr-0 p-5 py-2 mb-4 rounded-[0px_20px_20px_20px] bg-white ml-4 mb-1'>
                                    <CaretRightFill className='text-5xl absolute rotate-[-41deg] -left-5 -top-3.5' color='#ffffff'/>
                                    <p className='ai-response' dangerouslySetInnerHTML={{ __html: chat_bot.question }}></p>
                                    </div>
                                    {/* <p className="ml-6 text-[9px] mb-3">{ chat_bot.time }</p>  */}
                                </>
                                <><div className={`bubble relative p-5 mb-4 py-2 rounded-[20px_0px_20px_20px] bg-white ml-auto mr-3`}>
                                    <CaretRightFill className='text-5xl absolute right-[-18px] rotate-[222deg] -top-3.5' color={chat_bot.source !== "note" ? "#ffffff":"#f4e9bd"}/>
                                    <p className='ai-response'>{chat_bot.answer}</p>
                                </div>
                                </>
                                {(chat_bot.source === "assign" || chat_bot.source === "agent") && <div className="flex mb-3 justify-center">
                                    <span className="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20">
                                        {chat_bot.message}
                                    </span>
                                </div>}
                            </>
                        );
                    })}
                    {live_bot_listing?.summary != "" && <div className="flex mb-4 justify-center text-center">
                        <div
                            className="rounded-md bg-gray-50 w-[60%] p-2 cursor-pointer border border-gray-300"
                            onClick={()=>{ setListChatFlag(!listChatFlag) }}
                        >
                            <div>
                                <div>
                                    <h3 className="text-sm font-medium text-gray-800">Summary</h3>
                                    <div className="text-sm text-gray-700">
                                        <p>
                                            {live_bot_listing?.summary}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                    
                    {liveChatPrompt?.length > 0 && liveChatPrompt?.map((chat, chat_index) => {
                        return (
                            <>
                                {chat.source === "channel" && <>
                                    <div className='bubble-left relative mr-0 p-5 py-2 rounded-[0px_20px_20px_20px] bg-white ml-4 mb-1'>
                                    <CaretRightFill className='text-5xl absolute rotate-[-41deg] -left-5 -top-3.5' color='#ffffff'/>
                                    <p className='ai-response' dangerouslySetInnerHTML={{ __html: chat.message }}></p>
                                    </div>
                                    <p className="ml-6 text-[9px] mb-3">{ chat.time }</p> 
                                </>}
                                {(chat.source === "chatbot" || chat.source === "note") && <><div className={`bubble relative p-5 py-2 rounded-[20px_0px_20px_20px] ${chat.source !== "note" ? "bg-white":"bg-[#f4e9bd]"} ml-auto mr-3 mb-1`}>
                                    <CaretRightFill className='text-5xl absolute right-[-18px] rotate-[222deg] -top-3.5' color={chat.source !== "note" ? "#ffffff":"#f4e9bd"}/>
                                    <p className='ai-response'>{chat.message}</p>
                                    {chat.source !== "note" && <p className="italic flex items-center justify-end text-[9px] text-gray-600">{chat.seen_status} {chat.seen_status === "Sent" ? <Check className="h-4 w-4"/> : <CheckAll className="h-4 w-4"/>}</p>}
                                </div>
                                <div className="flex justify-end">
                                    <p className={`text-[9px] ${chat.source === "note" ? "mr-1":"mr-4"} mb-3 text-right`}>{chat.time} </p>
                                    {chat.source === "note" && <LockClosedIcon title="Only visible to you and your team" className="text-gray-600 cursor-pointer mr-3 w-3 h-3" />}
                                </div>
                                </>}
                                {(chat.source === "assign" || chat.source === "agent") && <div className="flex mb-3 justify-center">
                                    <span className="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20">
                                        {chat.message}
                                    </span>
                                </div>}
                            </>
                        );
                    })}
                    {/* {typingObject.userKey === true && 
                        <div className='bubble-left relative mr-0 p-5 py-2 rounded-[0px_20px_20px_20px] bg-white ml-4 mb-1'>
                            <CaretRightFill className='icon-shift' color='#ffffff'/>
                            <p className='ai-response m-0'>
                                <span>
                                    <img src={loader_dot} className='m-auto w-12' alt="loader-gif" />
                                </span>
                            </p>
                        </div>
                    } */}
                </div>
                <div className="conversation-footer">
                    {assignSelf === true && <div className="bg-[color-mix(in_srgb,var(--brand-primary)_20%,transparent)] h-12 flex justify-between items-center px-4">
                        <span>Would you like to assign this conversation to you ?</span>
                        <div className="flex gap-3">
                            <span
                                onClick={() => {
                                     let payload = {
                                        inbox_id: props.inboxParam,
                                        conversation_id: props.conversationParam,
                                        assignee_id: fetch_agent_id,
                                        assignee_name: agentCaptureData.first_name+ " " + agentCaptureData.last_name,
                                    }
                                    dispatch(assignConversationLead(authToken, payload, props.inboxParam, props.conversationParam))
                                    setAssignSelf(false);
                                }}
                                className="cursor-pointer inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-800 ring-1 ring-inset ring-yellow-600/20"
                            >
                                Yes
                            </span>
                            <span className="cursor-pointer inline-flex items-center rounded-md bg-red-50 px-1 py-0 text-xs font-medium text-red-800 ring-1 ring-inset ring-yellow-600/20">
                                <X onClick={() => {
                                    setText("");
                                    setAssignSelf(false)
                                }} className="w-4 h-4 text-red-600" />
                            </span>
                        </div>
                    </div>}
                    <div className="flex">
                        <div className="min-w-0 flex-1">
                            <div className="relative">
                            {showOverlay && canned_list?.length > 0 && <CannedResponseOverlay />}
                            <div className="overflow-hidden emoji-div shadow-sm border-t border-gray-300">
                                <label htmlFor="comment" className="sr-only">
                                    Message
                                </label>
                                {/* <textarea
                                    rows={3}
                                    name="comment"
                                    id="comment"
                                    className={`block listing w-full resize-none border-0 bg-transparent py-1.5 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6 ${editorStatus !== "note" ? "bg-white":"bg-yellow-50"}`}
                                    placeholder={`Add your ${editorStatus !== "note" ? "message":"private note"}...`}
                                    defaultValue={''}
                                /> */}
                                    
                                {/* <InputEmoji
                                    value={text}
                                    onChange={setText}
                                    cleanOnEnter
                                    onEnter={handleOnEnter}
                                    placeholder="Type a message"
                                /> */}
                                <EmojiTextArea
                                    value={text}
                                    placeholder={editorStatus !== "note" ? "Type a message..." : "Type a private note..."}
                                    className="listing"
                                        onChange={(e) => {
                                        if (e.includes('/')) {
                                            setShowOverlay(true);
                                            // Extract search text after "/"
                                            const searchTextIndex = e.lastIndexOf('/');
                                            setSearchCanned(e.substring(searchTextIndex + 1));
                                            } else {
                                            setShowOverlay(false);
                                            setSearchCanned('');
                                        }
                                        setFirebaseFlag(true);
                                        setText(e)
                                    }}
                                    onEmojiClick={handleEmojiClick}
                                    onKeyDown={(e) => { 
                                        if (fetch_select_data.assignee_id != fetch_agent_id && e.key === 'Enter') {
                                            setAssignSelf(true);
                                        } else {
                                            if (e.key === 'Enter') {
                                                setFirebaseFlag(false);
                                                dispatch(sendMessage(authToken, props.inboxParam, props.conversationParam, text, editorStatus !== "note" ? "chatbot":"note", onSuccessResponse));
                                                setText("");
                                            }
                                        }    
                                    }}
                                />

                                {/* Spacer element to match the height of the toolbar */}
                                <div className={`pb-2  ${editorStatus !== "note" ? "bg-white":"bg-yellow-50"}`} aria-hidden="true">
                                    {/* Matches height of button in toolbar (1px border + 36px content height) */}
                                    <div className="py-px">
                                        <div className="h-9" />
                                    </div>
                                </div>
                            </div>

                            <div className={`absolute inset-x-0 bottom-0 flex justify-between py-2 pl-3 pr-2 ${editorStatus !== "note" ? "bg-white":"bg-yellow-50"}`}>
                                <div className="flex items-center space-x-5">
                                    <div className="flex justify-center shadow-md border border-gray-300 rounded-lg">
                                        <button onClick={()=>{setEditorStatus("reply")}} className={`px-3 py-1 ${editorStatus !== "note" ? "bg-[var(--brand-primary)] text-white hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)]": "bg-white text-[var(--brand-primary)] hover:bg-gray-100"} text-xs font-normal rounded-l-lg focus:outline-none`}>
                                            Reply
                                        </button>
                                        <button onClick={()=>{setEditorStatus("note")}} className={`px-3 py-1 ${editorStatus !== "reply" ? "bg-[var(--brand-primary)] text-white hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)]": "bg-white text-[var(--brand-primary)] hover:bg-gray-100"} text-xs font-normal rounded-r-lg focus:outline-none`}>
                                            Private Note
                                        </button>
                                    </div>        
                                    <div className="flex items-center">
                                        <button
                                            type="button"
                                            onClick={()=>{setShow(true)}}            
                                            className="-m-2.5 flex h-10 focus-visible:outline-none w-10 items-center justify-center rounded-full text-gray-400 hover:text-gray-500"
                                        >
                                        <Fullscreen className="h-4 w-4" aria-hidden="true" />
                                        <span className="sr-only">Maximize</span>
                                        </button>
                                    </div>
                                    {/* <div className="flex items-center">
                                        <button
                                            type="button"
                                            onClick={handleButtonClick}        
                                            className="-m-2.5 flex h-10 w-10 items-center justify-center rounded-full text-gray-400 hover:text-gray-500"
                                        >
                                        <PaperClipIcon className="h-5 w-5" aria-hidden="true" />
                                        <span className="sr-only">Attach a file</span>
                                        </button>
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            onChange={handleFileChange}
                                            style={{ display: 'none' }} // Hide the input element
                                        />
                                    </div> */}
                                    {/* <div className="flex items-center">
                                        <button onClick={()=>{setAssistPop(true)}} className="button-color relative rounded bg-indigo-50 px-2 py-1 text-xs font-medium shadow-sm hover:bg-indigo-100">
                                            <span className="absolute -right-1 -top-1 flex h-3 w-3">
                                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[var(--brand-primary)] opacity-75"></span>
                                                <span className="relative opacity-60 inline-flex rounded-full h-3 w-3 bg-[var(--brand-primary)]"></span>
                                            </span>
                                            <span className="button__content flex gap-1 text-left rtl:text-right">
                                                <Magic/>AI Assist
                                            </span>
                                        </button>
                                    </div>         */}
                                </div>
                                <div className="flex-shrink-0">
                                <button
                                    type="submit"
                                    className="inline-flex items-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
                                    onClick={() => {
                                        setFirebaseFlag(false);
                                        if (fetch_select_data.assignee_id != fetch_agent_id ) {
                                            setAssignSelf(true);
                                        } else {
                                            dispatch(sendMessage(authToken, props.inboxParam, props.conversationParam, text, editorStatus !== "note" ? "chatbot" : "note", onSuccessResponse));
                                            setText("");
                                        }
                                    }}
                                >
                                    <Send/>
                                </button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
            
            
            {/* full screen input mode */}
            
            <Transition.Root show={show} as={Fragment}>
                <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={()=>{if(assistPop === false){setShow(false)}}}>
                    <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                    >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                        <Dialog.Panel className={`relative transform overflow-hidden border p-1 max-sm:w-full rounded-lg text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl ${editorStatus !== "note" ? "bg-[#f2f2f2] border-gray-300":"bg-yellow-100 border-yellow-300"}`}>
                            <div className={""}>
                            {/* {viewModal !== false && <h3 className="not-italic text-center mb-3 font-bold text-2xl leading-[29px] text-[#00000094]">{ "Preview" }</h3>} */}
                            <div className="d-flex flex-column popup-emoji">
                                <div className="w-full">
                                {/* <textarea
                                    ref={textareaRef}
                                    value={textValue}
                                    placeholder={`${editorStatus !== "note" ? "Shift + enter for new line. Start with '/' to select a Canned Response.":"Shift + enter for new line."}...`}
                                    className={`w-full h-[65vh] border-none inputBorder p-3 resize-none ${editorStatus !== "note" ? "bg-white":"bg-yellow-50"}`}
                                    onChange={(e)=>{ setTextValue(e.target.value) }}
                                    // disabled={viewModal === true}  
                                /> */}
                                <EmojiTextArea
                                    value={text}
                                    placeholder={editorStatus !== "note" ? "Type a message..." : "Type a private note..."}
                                    className="listing"
                                    onChange={setText}
                                    onEmojiClick={handleEmojiClick}
                                    onKeyDown={async (e) => {
                                        if (e.key === 'Enter') {
                                            dispatch(sendMessage(authToken, props.inboxParam, props.conversationParam, text, editorStatus !== "note" ? "chatbot":"note", onSuccessResponse));
                                            setText("");
                                            setShow(false)
                                        }
                                    }}
                                />
                                </div>
                                <div className="flex justify-between p-2">
                                    <div className="flex items-center space-x-5">
                                        <div className="flex justify-center shadow-md border border-gray-300 rounded-lg">
                                            <button onClick={()=>{setEditorStatus("reply")}} className={`px-3 py-1 ${editorStatus !== "note" ? "bg-[var(--brand-primary)] text-white hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)]": "bg-white text-[var(--brand-primary)] hover:bg-gray-100"} text-xs font-normal rounded-l-lg focus:outline-none`}>
                                                Reply
                                            </button>
                                            <button onClick={()=>{setEditorStatus("note")}} className={`px-3 py-1 ${editorStatus !== "reply" ? "bg-[var(--brand-primary)] text-white hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)]": "bg-white text-[var(--brand-primary)] hover:bg-gray-100"} text-xs font-normal rounded-r-lg focus:outline-none`}>
                                                Private Note
                                            </button>
                                        </div>        
                                        <div className="flex items-center">
                                            <button
                                            type="button"
                                            onClick={()=>{setShow(false)}}            
                                            className="-m-2.5 flex h-10 w-10 items-center justify-center rounded-full text-gray-400 hover:text-gray-500"
                                            >
                                            <FullscreenExit className="h-4 w-4" aria-hidden="true" />
                                            <span className="sr-only">Minimize</span>
                                            </button>
                                        </div>
                                        {/* <div className="flex items-center">
                                            <button
                                                type="button"
                                                onClick={handleButtonClick}        
                                                className="-m-2.5 flex h-10 w-10 items-center justify-center rounded-full text-gray-400 hover:text-gray-500"
                                            >
                                            <PaperClipIcon className="h-5 w-5" aria-hidden="true" />
                                            <span className="sr-only">Attach a file</span>
                                            </button>
                                            <input
                                                type="file"
                                                ref={fileInputRef}
                                                onChange={handleFileChange}
                                                style={{ display: 'none' }} // Hide the input element
                                            />
                                        </div> */}
                                        <div className="flex items-center">
                                            <button onClick={()=>{setAssistPop(true)}} className="button-color relative rounded bg-indigo-50 px-2 py-1 text-xs font-medium shadow-sm hover:bg-indigo-100">
                                                <span className="absolute -right-1 -top-1 flex h-3 w-3">
                                                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[var(--brand-primary)] opacity-75"></span>
                                                    <span className="relative opacity-60 inline-flex rounded-full h-3 w-3 bg-[var(--brand-primary)]"></span>
                                                </span>
                                                <span className="button__content flex gap-1 text-left rtl:text-right">
                                                    <Magic/>AI Assist
                                                </span>
                                            </button>
                                        </div>
                                    </div>                
                                    <button
                                        type="submit"
                                        className="inline-flex items-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
                                        
                                    >
                                        <Send/>
                                    </button>
                                </div>
                            </div>
                            </div>
                        </Dialog.Panel>
                        </Transition.Child>
                    </div>
                    </div>
                </Dialog>
            </Transition.Root>
            
            {/* AI assist popup */}
            
            <Transition.Root show={assistPop} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={handleClose}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl sm:p-6">
                            <div>
                                <p className="flex text-lg leading-6 font-medium">AI Assist</p>    
                                <p className="flex border-b pb-2 border-gray-200 mb-2 text-xs">Bring advanced AI features to your dashboard with OpenAI's GPT models.</p>                                        
                                {error === true && <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-500 w-full">
                                    Please add message first.
                                </span>}
                                <div className="mt-2">
                                    <label htmlFor="label" className="block text-sm font-medium leading-6 text-gray-900">
                                        Original Message
                                    </label>
                                    <div>
                                        <textarea
                                            rows={3}
                                            autoFocus        
                                            name="message"
                                            id="message"
                                            placeholder="Type message here..."
                                            className="block w-full rounded-md resize-none border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset listing focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                            value={assistMessage}
                                            onChange={(e) => { setAssistMessage(e.target.value) }}
                                            required        
                                        />
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <label htmlFor="label" className="block text-sm font-medium leading-6 text-gray-900">
                                        Select AI Action
                                    </label>
                                    <Listbox value={assistAction} onChange={(e) => {
                                        if (assistMessage !== "") {
                                            setAssistAction(e);
                                            handleAiAssist(e?.name);
                                            setError(false);
                                        } else {
                                            setError(true);
                                        }     
                                    }}>
                                        {({ open }) => (
                                            <>
                                            <div className="relative mt-2">
                                                <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6">
                                                <span className="block truncate">{assistAction?.name || "Select the action ..."}</span>
                                                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                    <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                </span>
                                                </Listbox.Button>

                                                <Transition
                                                show={open}
                                                as={Fragment}
                                                leave="transition ease-in duration-100"
                                                leaveFrom="opacity-100"
                                                leaveTo="opacity-0"
                                                >
                                                <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                    {assistStatus.map((assist) => (
                                                    <Listbox.Option
                                                        key={assist.id}
                                                        className={({ active }) =>
                                                        classNames(
                                                            active ? 'bg-[var(--brand-primary)] text-white' : 'text-gray-900',
                                                            'relative cursor-default select-none py-2 pl-3 pr-9'
                                                        )
                                                        }
                                                        value={assist}
                                                    >
                                                        {({ selected, active }) => (
                                                        <>
                                                            <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                            {assist.name}
                                                            </span>

                                                            {selected ? (
                                                            <span
                                                                className={classNames(
                                                                active ? 'text-white' : 'text-[var(--brand-primary)]',
                                                                'absolute inset-y-0 right-0 flex items-center pr-4'
                                                                )}
                                                            >
                                                                <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                            </span>
                                                            ) : null}
                                                        </>
                                                        )}
                                                    </Listbox.Option>
                                                    ))}
                                                </Listbox.Options>
                                                </Transition>
                                            </div>
                                            </>
                                        )}
                                        </Listbox>       
                                </div>
                                <div className="mt-2">
                                    <label htmlFor="description" className="block text-sm font-medium leading-6 text-gray-900">
                                        AI generated response
                                    </label>
                                    <div>
                                        <div className="rounded-md bg-yellow-50 min-h-[24vh] p-2">
                                            {loaderGif !== true ? <div className="flex">
                                                <div className="ml-3">
                                                    <div className="mt-2 text-sm text-yellow-700">
                                                       {aiResponse !== "" ? <p>{aiResponse}</p>:<p className="py-12 px-32">Please add message and action</p>}
                                                    </div>
                                                </div>
                                            </div> :               
                                            <div className="flex justify-center">
                                                <div className="ml-3">
                                                    <div className="mt-2 text-sm text-yellow-700">
                                                        <img src={zoiReadingEmote} className="h-32 w-32" alt="gif" />
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                                        
                                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                    <button
                                        type="button"
                                        className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] sm:ml-3 sm:w-auto"
                                        onClick={() => {
                                            if(assistMessage !== ""){
                                                dispatch(sendMessage(authToken, props.inboxParam, props.conversationParam, aiResponse || assistMessage, editorStatus !== "note" ? "chatbot" : "note", onSuccessResponse));
                                                handleClose();
                                                setError(false);
                                            } else {
                                                setError(true);
                                            }  
                                        }}

                                    >
                                        Send
                                    </button>
                                    <button
                                        type="button"
                                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </Dialog.Panel>
                        </Transition.Child>
                    </div>
                    </div>
                </Dialog>
            </Transition.Root>
            
        </>
    );    
}
